import { envEnabled } from "tools";
export const disableAuth = envEnabled("NEXT_PUBLIC_DISABLE_LOGIN");
